import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertComponent } from './alert.component';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  config: any = {

  }

  constructor(public dialog: MatDialog) { }


  openDialog(config: any): void {
    this.config = config;

    const dialogRef = this.dialog.open(AlertComponent, {
      // data: {name: this.name, animal: this.animal},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'confirm' && config.onConfirm) {
        config.onConfirm();
      } else if (result === 'cancel' && config.onCancel) {
        config.onCancel();
      } else if (!result && config.onCancel) {
        // Si el usuario cerró el modal sin confirmar (ESC, clic fuera, etc.)
        // se trata como cancelación
        config.onCancel();
      }
    });
  }
}
